import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-brown-primary text-cream py-16 px-4" data-id="element-30">
      <div className="max-w-3xl mx-auto text-center" data-id="element-31">
        <div className="flex justify-center mb-6" data-id="element-32">
          <ShieldCheckIcon className="w-16 h-16 text-gold-soft" data-id="element-33" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold mb-6 font-serif" data-id="element-34">
          7 DÍAS SIN PREGUNTAS
        </h2>
        <p className="text-lg md:text-xl text-cream/80 leading-relaxed mb-8" data-id="element-35">
          Descárgalo, léelo, ve a la farmacia. Si sientes que este método no
          vale al menos 10 veces lo que pagaste, pide tu reembolso en Hotmart.
          Te devuelvo cada centavo.
        </p>
        <p className="text-2xl font-serif italic text-gold-soft" data-id="element-36">
          El riesgo es 100% mío.
        </p>
      </div>
    </section>;
}